/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useRef} from 'react';
import {
  TableDefault,
  ShadowTableHead,
  StickyMainHeader,
  StickySubHeader,
  ArrowHolderSummary,
  ColumnContainerSummary,
  TeamAverageRow,
  ShadowSummaryColumn,
  ArrowDownContainer,
  StickyShadowMainHeader,
} from './styles';
import {Utils} from '../../utils/api';
import {GoChevronDown, GoChevronUp, GoArrowDown} from 'react-icons/go';
import numberColumnFormatter from '../../utils/hooks/number-column-formatter';
import getFatigueZoneBullet from '../../utils/hooks/fatigue-zone-bullet';
import HideOn from '../../assets/icons/HideOn.png';
import HideOff from '../../assets/icons/HideOff.png';
import Loader from '../loader/loader';

export default ({
  dataTableContent,
  average,
  dataCy,
  fatigueZone,
  setTableUpdated,
  hideExam,
}: {
  dataTableContent: Array<any>;
  average?: any;
  dataCy?: string;
  fatigueZone?: boolean;
  setTableUpdated?: any;
  hideExam?: any;
}) => {
  const [table, useTable] = useState<Array<any>>(dataTableContent);
  const [sort, useSort] = useState<string>('');
  const [reverse, useReverse] = useState<boolean>(false);
  const sortOptions = [!reverse, changeTable, table];
  const [loading, useLoading] = useState<boolean>(false);
  const UTILS = new Utils();

  useEffect(() => {
    useTable(dataTableContent);
    useLoading(false);
  }, [dataTableContent]);

  useEffect(() => {
    if (loading) {
      setTableUpdated(true);
    }
  }, [loading]);

  function changeTable(e) {
    useTable([...e]);
  }

  function toggleSortDate(sort, params) {
    const sortOptions = [!reverse, changeTable, table];
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortIsoDate(params, sortOptions);
  }

  function toggleSortString(sort, params) {
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortStrings(params, sortOptions);
  }
  function toggleSortNumber(sort, params) {
    useSort(sort);
    useReverse(!reverse);
    UTILS.HandleSorted(params, sortOptions);
  }
  function toggleSortFlexion(sort, params) {
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortStringsAndNumbers(params, [!reverse, changeTable, table]);
  }
  function SortingTableHead({title = '', attr, location, sortFunction}) {
    return (
      <StickySubHeader onClick={() => sortFunction(attr, location)}>
        <ColumnContainerSummary>
          <span>{title}</span>
          <ArrowHolderSummary>
            {sort === attr && reverse && <GoChevronDown size={14} />}
            {sort === attr && !reverse && <GoChevronUp size={14} />}
          </ArrowHolderSummary>
        </ColumnContainerSummary>
      </StickySubHeader>
    );
  }
  function SortingShadowTableHead({title = '', attr, location, sortFunction}) {
    return (
      <ShadowTableHead onClick={() => sortFunction(attr, location)}>
        <ColumnContainerSummary>
          <span>{title}</span>
          <ArrowHolderSummary>
            {sort === attr && reverse && <GoChevronDown size={14} />}
            {sort === attr && !reverse && <GoChevronUp size={14} />}
          </ArrowHolderSummary>
        </ColumnContainerSummary>
      </ShadowTableHead>
    );
  }

  function changeStatus(change) {
    // Downward arrows hidden per requirements - logic preserved
    // if (Math.trunc(change) < 0) {
    //   return (
    //     <ArrowDownContainer>
    //       <GoArrowDown size="10px" color="#fff" />
    //     </ArrowDownContainer>
    //   );
    // }
    return null;
  }
  return (
    <TableDefault data-cy={dataCy} minWidth="1200px">
      <thead>
        <tr>
          <StickyMainHeader colSpan={1}>HIDE</StickyMainHeader>
          <StickyMainHeader colSpan={1}>DATE</StickyMainHeader>
          <StickyMainHeader colSpan={1}>EXAM TYPE</StickyMainHeader>
          <StickyShadowMainHeader colSpan={2}>TOTAL ARC</StickyShadowMainHeader>
          <StickyMainHeader colSpan={2}>INTERNAL ROTATION</StickyMainHeader>
          <StickyShadowMainHeader colSpan={2}>EXTERNAL ROTATION</StickyShadowMainHeader>
          <StickyMainHeader colSpan={2}>FLEXION</StickyMainHeader>
        </tr>
        <tr>
          <StickySubHeader />
          <SortingTableHead title="Date" attr="date" location={['createdAt']} sortFunction={toggleSortDate} />
          <SortingTableHead title="Type" attr="type" location={['type']} sortFunction={toggleSortString} />
          <SortingShadowTableHead title="Current" attr="tArcCurrent" location={['rom', 'tArcCurrent']} sortFunction={toggleSortNumber} />
          <SortingShadowTableHead title="Change" attr="tArcChange" location={['rom', 'tArcChange']} sortFunction={toggleSortNumber} />
          <SortingTableHead title="Current" attr="irCurrent" location={['rom', 'irCurrent']} sortFunction={toggleSortNumber} />
          <SortingTableHead title="Change" attr="irChange" location={['rom', 'irChange']} sortFunction={toggleSortNumber} />
          <SortingShadowTableHead title="Current" attr="erCurrent" location={['rom', 'erCurrent']} sortFunction={toggleSortNumber} />
          <SortingShadowTableHead title="Change" attr="erChange" location={['rom', 'erChange']} sortFunction={toggleSortNumber} />
          <SortingTableHead title="Current" attr="flexionDegrees" location={['rom', 'flexionDegrees']} sortFunction={toggleSortFlexion} />
          <SortingTableHead title="Change" attr="flexionChange" location={['rom', 'flexionChange']} sortFunction={toggleSortFlexion} />
        </tr>
      </thead>
      <tbody onClick={() => useSort('')}>
        {table.length > 0 && (
          <TeamAverageRow>
            <td>Avg</td>
            <td>{loading && <Loader width="20px" color="#B1D6FF" />}</td>
            <td></td>
            <ShadowSummaryColumn>{numberColumnFormatter(average?.avgTotalArcCurrent, {digits: 0})}</ShadowSummaryColumn>
            <ShadowSummaryColumn>
              {numberColumnFormatter(average?.avgTotalArcChange, {digits: 0})}
              {changeStatus(average?.avgTotalArcChange)}
            </ShadowSummaryColumn>
            <td>{numberColumnFormatter(average?.avgIRRomCurrent, {digits: 0})}</td>
            <td>
              {numberColumnFormatter(average?.avgIRRomChange, {digits: 0})}
              {changeStatus(average?.avgIRRomChange)}
            </td>
            <ShadowSummaryColumn>{numberColumnFormatter(average?.avgERRomCurrent, {digits: 0})}</ShadowSummaryColumn>
            <ShadowSummaryColumn>
              {numberColumnFormatter(average?.avgERRomChange, {digits: 0})}
              {changeStatus(average?.avgERRomChange)}
            </ShadowSummaryColumn>
            <td>{numberColumnFormatter(average?.avgFlexionCurrent, {digits: 0})}</td>
            <td>
              {numberColumnFormatter(average?.avgFlexionChange, {digits: 0})}
              {changeStatus(average?.avgFlexionChange)}
            </td>
          </TeamAverageRow>
        )}
        {table.length > 0 ? (
          table.map((item, index) => {
            return (
              <TableItem
                key={index}
                item={item}
                useLoading={useLoading}
                fatigueZone={fatigueZone}
                changeStatus={changeStatus}
                hideExam={hideExam}
              />
            );
          })
        ) : (
          <tr>
            <td colSpan={25}>No Data</td>
          </tr>
        )}
      </tbody>
    </TableDefault>
  );
};

const TableItem = ({item, useLoading, fatigueZone, changeStatus, hideExam}) => {
  const [hide, setHide] = useState<Boolean>(item.excludeFromExamAvg);
  const [opacity, setOpacity] = useState<string>(item.excludeFromExamAvg ? '0.5' : '1');

  const firstUpdate = useRef(true);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    hide ? setOpacity('0.5') : setOpacity('1');
    hideExam(item._id, hide, 'fresh');
    useLoading(true);
  }, [hide]);

  function handleDate(date) {
    return date ? new Date(date).toLocaleDateString('en-US') : '-';
  }

  return (
    <tr style={{opacity: opacity}}>
      <td className="white pointer" onClick={() => setHide(!hide)}>
        {hide ? <img src={HideOn} alt="hideOn" /> : <img src={HideOff} alt="hideOn" />}
      </td>
      <td className="white">{handleDate(item?.createdAt)}</td>
      <td className="white">{item?.type}</td>
      <td>
        {numberColumnFormatter(item?.rom?.tArcCurrent, {digits: 0})}
        {fatigueZone && getFatigueZoneBullet(item?.rom?.tArcStatus)}
      </td>
      <td>
        {numberColumnFormatter(item?.rom?.tArcChange, {digits: 0})}
        {changeStatus(item?.rom?.tArcChange)}
      </td>
      <td className="white">
        {numberColumnFormatter(item?.rom?.irCurrent, {digits: 0})}
        {fatigueZone && getFatigueZoneBullet(item?.rom?.irStatus)}
        {changeStatus(item?.rom?.irStatus)}
      </td>
      <td className="white">
        {numberColumnFormatter(item?.rom?.irChange, {digits: 0})}
        {changeStatus(item?.rom?.irChange)}
      </td>
      <td>
        {numberColumnFormatter(item?.rom?.erCurrent, {digits: 0})}
        {fatigueZone && getFatigueZoneBullet(item?.rom?.erStatus)}
      </td>
      <td>
        {numberColumnFormatter(item?.rom?.erChange, {digits: 0})}
        {changeStatus(item?.rom?.erChange)}
      </td>
      <td className="white">{item?.rom?.flexion || item?.rom?.flexionDegrees || '-'}</td>
      <td className="white">{item?.rom?.flexionChange || '-'}</td>
    </tr>
  );
};
